import React from "react";
import HeroImage from "../components/HeroImage";
import HeroVideo1 from "../components/HeroVideo1";
import { galleryImages } from "../utils/galleryData";
import backgroundimage from "../assets/images/gallery.png";
import video2 from "../assets/videos/service2.mp4";
import ImagesSlider from "../components/ImagesSlider";
import TikTok from "../components/TikTok/TikTokFeed";

function Gallery() {
  return (
    <div className="bg-black">
      <HeroImage backgroundImage={backgroundimage} heading="GALERIJ" />
      <ImagesSlider images={galleryImages} />
      <TikTok />
      <HeroVideo1
        videoSource={video2}
        heading="Enthousiast geworden en wilt u uw auto ook terugzien op onze website?Klik hier om een afspraak te maken."
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default Gallery;
